(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
      this.stickyTypeDesktop = this.getAttribute('data-sticky-type-desktop') || 'none';
      this.stickyTypeMobile = this.getAttribute('data-sticky-type-mobile') || this.stickyTypeDesktop;
      this.partialRevealHeightDesktop = this.getAttribute('data-partial-reveal-height-desktop') || '0';
      this.partialRevealHeightMobile = this.getAttribute('data-partial-reveal-height-mobile') || this.partialRevealHeightDesktop;
      this.stickyType = this.getCurrentStickyType();
      this.partialStickyMode = this.stickyType === 'on-scroll-up-partial';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};
      this.onViewportChange = this.handleViewportChange.bind(this);

      this.setHeaderHeight();

      this.desktopMediaQuery.addEventListener('change', this.onViewportChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    getCurrentStickyType() {
      return this.desktopMediaQuery.matches ? this.stickyTypeDesktop : this.stickyTypeMobile;
    }

    getCurrentPartialRevealHeight() {
      return this.desktopMediaQuery.matches ? this.partialRevealHeightDesktop : this.partialRevealHeightMobile;
    }

    setHeaderHeight() {
      this.stickyType = this.getCurrentStickyType();
      this.partialStickyMode = this.stickyType === 'on-scroll-up-partial';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (this.partialStickyMode) {
        const configuredRevealHeight = parseInt(this.getCurrentPartialRevealHeight() || '0', 10);
        const revealHeight = Math.max(0, Math.min(configuredRevealHeight, this.header.offsetHeight));
        this.header.style.setProperty('--sticky-reveal-height', `${revealHeight}px`);
      } else {
        this.header.style.setProperty('--sticky-reveal-height', '0px');
      }
    }

    handleViewportChange() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-partial-reveal', 'animate');
      this.setHeaderHeight();
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      } else if ((window.pageYOffset || document.documentElement.scrollTop) <= this.headerBounds.top) {
        this.header.classList.remove('shopify-section-header-sticky');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.desktopMediaQuery.removeEventListener('change', this.onViewportChange);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-partial-reveal');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (this.partialStickyMode) {
        this.header.classList.add('shopify-section-header-partial-reveal');
      }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'shopify-section-header-partial-reveal', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
